import React from 'react';

export function Field({ className = '', children, ...props }) {
  return (
    <div className={`grid gap-2 ${className}`} {...props}>
      {children}
    </div>
  );
}

export function Label({ className = '', htmlFor, children, ...props }) {
  return (
    <label
      htmlFor={htmlFor}
      className={`text-sm font-medium text-zinc-950 dark:text-white ${className}`}
      {...props}
    >
      {children}
    </label>
  );
}

export default { Field, Label }; 